import { render, staticRenderFns } from "./SupporterEditAddress.vue?vue&type=template&id=71c5b763&"
import script from "./SupporterEditAddress.vue?vue&type=script&lang=js&"
export * from "./SupporterEditAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c5b763')) {
      api.createRecord('71c5b763', component.options)
    } else {
      api.reload('71c5b763', component.options)
    }
    module.hot.accept("./SupporterEditAddress.vue?vue&type=template&id=71c5b763&", function () {
      api.rerender('71c5b763', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Details/SupporterEditAddress.vue"
export default component.exports